var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ButtonPrimary',_vm._g(_vm._b({attrs:{"disabled":_vm.disabled,"label":_vm.label}},'ButtonPrimary',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }